var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFigmaWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 14,
  fill: "currentColor"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_16263_58232)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.0195 13.9997C14.0195 12.5269 15.2134 11.333 16.6862 11.333C18.1589 11.333 19.3528 12.5269 19.3528 13.9997C19.3528 15.4724 18.1589 16.6663 16.6862 16.6663C15.2134 16.6663 14.0195 15.4724 14.0195 13.9997Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.68555 19.333C8.68555 17.8602 9.87945 16.6663 11.3522 16.6663L12.7733 15.916L14.0189 16.6663V19.333C14.0189 20.8057 12.825 21.9996 11.3522 21.9996C9.87945 21.9996 8.68555 20.8057 8.68555 19.333Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.0194 6L12.5684 8.52094L14.0194 11.3333H16.6487C18.1215 11.3333 19.3153 10.1394 19.3153 8.66666C19.3153 7.19391 18.1214 6 16.6487 6H14.0194Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.64844 8.66666C8.64844 10.1394 9.84234 11.3333 11.3151 11.3333L12.7297 11.8797L14.0192 11.3333V6H11.3151C9.84234 6 8.64844 7.19391 8.64844 8.66666Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.68555 13.9997C8.68555 15.4725 9.87945 16.6664 11.3522 16.6664H14.0189V11.333H11.3522C9.87945 11.333 8.68555 12.5269 8.68555 13.9997Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_16263_58232"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16.7044,
  height: 15.9996,
  fill: "currentColor",
  transform: "translate(5.64844 6)"
})))));
export default SvgFigmaWhite;